import React from 'react';
import type { IconComponentProps } from '@/types/components';

interface Props extends IconComponentProps {
  strokeWidth?: string;
}

const DEFAULT_STROKE_WIDTH = '1.5';

export const PlusSign: React.FC<Props> = ({
  className,
  strokeWidth = DEFAULT_STROKE_WIDTH,
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#plus-sign-clip)">
      <path
        d="M8.12146 2.55566V13.6754"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6868 8.11523H2.5556"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="plus-sign-clip">
        <rect width="14" height="14" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);
